const desc = `<p class="c0" dir="rtl">
  <span class="c4"
    >למיטב ידיעתינו זהו הסיפור המוקדם ביותר. נראה שהיתה כוונה לפרסמו בעיתון אך
    איננו יודעים אם אכן פורסם.
  </span>    
</p>`;

export default desc;
